import request from '@/utils/request';

/**
 * 登录
 * @param
 */
export function loginUser(params) {
  return request({
    url: 'biodata/hfd/loginUser',
    method: 'post',
    data: params,
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded"
    // }
  });
}

/**
 * Explore——umap图
 * @param
 */
export function getUmapData(data) {
  return request({
    url: 'slot/api/getUmapData',
    method: 'post',
    data,
  });
}

/**
 * Explore——定位图
 * @param
 */
export function getLocationUrls(data) {
  return request({
    url: 'slot/api/getLocationUrls',
    method: 'post',
    data,
  });
}

/**
 * Explore 联想查询基因名
 * @param
 */
export function getUmapGenes(data) {
  return request({
    url: 'slot/api/getUmapGenes',
    method: 'post',
    data,
  });
}

/**
 * Download页面
 * @param
 */
export function sendMail(data) {
  return request({
    url: 'slot/api/sendMail',
    method: 'post',
    data,
  });
}
